






























































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import WorkerSearchRequest from '@/models/Workers/WorkerSearchRequest';
import { BookingDetailsModule } from '@/store/modules/bookingDetails';
import PositionDto from '@/models/Positions/PositionDto';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog'
import BranchDto from '@/models/Branches/BranchDto';


@Component({
    name: 'BookingBrowseWorkerSearchCriteria'
})
export default class extends GiganautVueDialog {
 
  public dialog = false;
  public checkAllShifts = true; // Toggle state for showing/hiding shift picker
  
  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      if (AgencySettingsModule.positions.length === 0) {
        await AgencySettingsModule.getPositions();
      }
      if (AgencySettingsModule.skills.length === 0) {
        await AgencySettingsModule.getSkills();
      }
      if (AgencySettingsModule.qualifications.length === 0) {
        await AgencySettingsModule.getQualifications();
      }
      if (AgencySettingsModule.branches.length === 0) {
        await AgencySettingsModule.getBranches();
      }
    }
  } 

  get positions() {
    return AgencySettingsModule.positions;
  }

  get skills() {
    return AgencySettingsModule.skills;
  }

  @Watch('searchOptions.selectedBranch')
  onSelectedBranchChanged(val: BranchDto, oldVal: BranchDto) {
    if (!val) {
      this.searchOptions.selectedDesk = null;
    }
  }

  get branches() {
    return AgencySettingsModule.branches;
  }

  get desks() {
    if (this.searchOptions.selectedBranch) {
      return this.searchOptions.selectedBranch.desks;
    }
    return [];
  }

  get qualifications() {
    return AgencySettingsModule.qualifications;
  }

  get searchOptions() {
      return BookingDetailsModule.workerSearchViewModel;
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  get availableShifts() {
    if (BookingDetailsModule.selectedBookingRole && BookingDetailsModule.selectedBookingRole.shifts) {
      return BookingDetailsModule.selectedBookingRole.shifts;
    }
    return [];
  }

  @Watch('checkAllShifts')
  onCheckAllShiftsChanged(value: boolean) {
    if (value) {
      // When toggled ON, select all shifts
      this.selectAllShifts();
    }
  }

  formatShiftLabel(shift: any): string {
    // Handle both Date objects and ISO strings
    const startDate = shift.startAt instanceof Date ? shift.startAt : new Date(shift.startAt);
    const endDate = shift.endAt instanceof Date ? shift.endAt : new Date(shift.endAt);
    
    const dateOptions: Intl.DateTimeFormatOptions = { 
      weekday: 'short', 
      month: 'short', 
      day: 'numeric',
      year: 'numeric'
    };
    const timeOptions: Intl.DateTimeFormatOptions = { 
      hour: '2-digit', 
      minute: '2-digit',
      hour12: false
    };
    
    const formattedDate = startDate.toLocaleDateString('en-US', dateOptions);
    const formattedStartTime = startDate.toLocaleTimeString('en-US', timeOptions);
    const formattedEndTime = endDate.toLocaleTimeString('en-US', timeOptions);
    
    return `${formattedDate} | ${formattedStartTime} - ${formattedEndTime}`;
  }

  selectAllShifts() {
    this.searchOptions.selectedShiftIds = this.availableShifts.map((shift: any) => shift.id);
  }

  deselectAllShifts() {
    this.searchOptions.selectedShiftIds = [];
  }

  async reset() {
    await BookingDetailsModule.resetAdvancedWorkerSearch()
  }

  async search() {
    this.dialog = false;
    await BookingDetailsModule.browseAdvancedWorkerSearch()
  }
}
